<template>
    <fieldset
        :id="controlId"
        :class="{
            '--required': required
        }"
    >
        <legend class="lni-c-input-list__legend">{{ labelText }}</legend>
        <div class="lni-o-grid--wrap">
            <x-input-tel
                ref="phone"
                class="lni-u-mt0"
                :data-label-text="labelText + ' main'"
                :data-control-id="controlId + '_phone'"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                :data-required="required"
                :is-nested="true"
                data-short-name = "Phone"
                customWidth="true"
                maxlength="12"
                :hideLabel="true"
                :pattern="'\\d{3}[\\-]\\d{3}[\\-]\\d{4}'"
                v-mask="{pattern: '###-###-####', separator: '-'}"
                @dataChanged="onDataChanged"
                @errorChanged="onPhoneErrorChanged"
                >
                <x-error v-if="errorText('phone')" :data-local-text="errorText('phone')" />
            </x-input-tel>
            <x-input-tel
                ref="ext"
                class="lni-u-mt0"
                :data-control-id="controlId + '_ext'"
                :data-parent-id="controlId"
                :data-parent-short-name="shortName"
                :is-nested="true"
                data-short-name = "Ext"
                data-label-text="ext"
                inline="true"
                customWidth="true"
                maxlength="5"
                v-mask="{pattern:'#####'}"
                @dataChanged="onDataChanged"
                @errorChanged="onExtErrorChanged"
            >
                <x-error v-if="errorText('ext')" :data-local-text="errorText('ext')" />
            </x-input-tel>
        </div>

    </fieldset>
</template>

<script>
import framework from '../../framework';
import mask from '../directives/mask';

export default {
    name: 'x-input-phone',
    mixins: [
        framework.mixins.abstractAggregateInput,
    ],
    directives: {
        mask,
    },
    mounted() {
        this.initialize();
    },
    computed: {
        componentValue: {
            get() {
                return {
                    phone: this.$refs.phone.value,
                    ext: this.$refs.ext.value,
                };
            },
            set(newValue) {
                this.$refs.phone.value = this.$refs.phone.$el.mask.formatString(newValue.phone);
                this.$refs.ext.value = this.$refs.ext.$el.mask.formatString(newValue.ext);
            },
        },
        /**
        * The text for the label.
        * @returns {string} label text.
        */
        labelText() {
            return this.getAttribute('labelText', '');
        },
    },
    methods: {
        /**
        * Adds the error from the child component to the errors of this component
        * @param {string} errorMessage The error message that the child component is passing.
        * @returns {void}
        */
        onPhoneErrorChanged(errorMessage) {
            this.onErrorChanged('phone', errorMessage);
        },
        /**
        * Adds the error from the child component to the errors of this component
        * @param {string} errorMessage The error message that the child component is passing.
        * @returns {void}
        */
        onExtErrorChanged(errorMessage) {
            this.onErrorChanged('ext', errorMessage);
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-input-phone/x-input-phone.vue